import { MESSAGING_FEATURE_FLAG } from './constants/messagingConstants';

const routes = [
  {
    path: '/inbox',
    name: 'messaging',
    component: () => import(/* webpackChunkName: "MessagingPage" */ './views/MessagingPage.vue'),
    props: (route) => ({
      featureFlag: MESSAGING_FEATURE_FLAG,
      angularRoute: 'app.inbox',
      angularRouteParams: { folder: route.query.folder, action: route.query.action },
      query: route.query,
    }),
    meta: { i18n: 'messaging-pov', pageNameEn: 'Messaging' },
  },
  {
    path: '/messaging',
    redirect: (to) => ({ path: '/inbox', query: to.query }),
  },
];

export default routes;
